import PaymentsModal from './PaymentsModal';

export default PaymentsModal;
